import { ApiError } from './client'

export async function publicGet<T>(path: string): Promise<T> {
  const res = await fetch(path)
  if (!res.ok) throw new ApiError(res.status, await res.text().catch(() => ''))
  return res.json() as Promise<T>
}
